import type { AdminSidebarComponentProps } from '@website-editor/customComponents/JsonComponent.types';
import { CustomJSONBlobComponent, GuestSiteComponentProps } from './types';
import { ThingsToDoConfig } from '@website-editor/customComponents/ThingsToDo/ThingsToDo.config';
import { DefaultThingsToDoConfig } from '@website-editor/customComponents/DefaultThingsToDo/DefaultThingsToDo.config';
import { GeneralScheduleConfig } from '@website-editor/customComponents/GeneralSchedule/GeneralSchedule.config';
import { FormDisplayConfig } from '@website-editor/customComponents/FormDisplay/FormDisplay.config';
import { VipConfig } from '@website-editor/customComponents/Vip/Vip.config';
import { WeatherReportConfig } from '@website-editor/customComponents/WeatherReport/WeatherReport.config';
import { FaqConfig } from '@website-editor/customComponents/Faq/Faq.config';
import { PlaceToStayComponentConfig } from '@website-editor/customComponents/PlaceToStayComponent/PlaceToStayComponent.config';

// Add all your custom components here so they can be picked up and rendered.
// NOTE: The rendering order matters - components appear in the "Add Component" list
// in the admin interface in the same order as defined here. This order determines
// the visual priority and display sequence when users are selecting components to add.
export const CUSTOM_JSON_COMPONENT_TYPES: ReadonlyArray<CustomJSONBlobComponent<AdminSidebarComponentProps, GuestSiteComponentProps>> = [
  PlaceToStayComponentConfig,
  ThingsToDoConfig,
  DefaultThingsToDoConfig,
  GeneralScheduleConfig,
  FormDisplayConfig,
  VipConfig,
  WeatherReportConfig,
  FaqConfig,
];

export type CustomJsonComponentConfig = (typeof CUSTOM_JSON_COMPONENT_TYPES)[number];
